export default "__VITE_ASSET__b073f971__"